// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!../../../styles/typography.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CgmSampleIntervalTooltip--container--aErJR {
  width: 260px;
}

.CgmSampleIntervalTooltip--row--eGul6 {
  line-height: 16px;
  color: var(--stat--default);
  margin-bottom: 8px;
  font-weight: medium;
}

.CgmSampleIntervalTooltip--title--_66g9 {
  font-weight: bold;
}

.CgmSampleIntervalTooltip--subtitle--JmGtI {
}

.CgmSampleIntervalTooltip--annotations--aTY6z {
  padding-left: 24px;
  margin: 0 0 6px;
}

.CgmSampleIntervalTooltip--annotation--sxBIG {
  margin-bottom: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/tooltips/CgmSampleIntervalTooltip.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EAEE,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EAEE,iBAAiB;AACnB;;AAEA;AAEA;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EAEE,kBAAkB;AACpB","sourcesContent":[".container {\n  width: 260px;\n}\n\n.row {\n  composes: smallSize from '../../../styles/typography.css';\n  line-height: 16px;\n  color: var(--stat--default);\n  margin-bottom: 8px;\n  font-weight: medium;\n}\n\n.title {\n  composes: row;\n  font-weight: bold;\n}\n\n.subtitle {\n  composes: row;\n}\n\n.annotations {\n  padding-left: 24px;\n  margin: 0 0 6px;\n}\n\n.annotation {\n  composes: row;\n  margin-bottom: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `CgmSampleIntervalTooltip--container--aErJR`,
	"row": `CgmSampleIntervalTooltip--row--eGul6 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["smallSize"]}`,
	"title": `CgmSampleIntervalTooltip--title--_66g9 CgmSampleIntervalTooltip--row--eGul6 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["smallSize"]}`,
	"subtitle": `CgmSampleIntervalTooltip--subtitle--JmGtI CgmSampleIntervalTooltip--row--eGul6 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["smallSize"]}`,
	"annotations": `CgmSampleIntervalTooltip--annotations--aTY6z`,
	"annotation": `CgmSampleIntervalTooltip--annotation--sxBIG CgmSampleIntervalTooltip--row--eGul6 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["smallSize"]}`
};
export default ___CSS_LOADER_EXPORT___;
